import { useState, useCallback, useEffect } from 'react';
import { translations, Language } from '../i18n/translations';

const LANGUAGE_STORAGE_KEY = 'mephist_lang';

export const useLanguage = () => {
  const getInitialLang = (): Language => {
    if (typeof window === 'undefined') return 'ru'; // SSR защита

    // 1. Пытаемся прочитать из localStorage
    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (stored === 'ru' || stored === 'en') {
        return stored;
      }
    } catch (e) {
      console.warn('localStorage access failed:', e);
    }

    // 2. Если в localStorage ничего нет, определяем язык браузера
    const browserLang = navigator.language || (navigator as any).userLanguage || '';

    const startsWithAny = (str: string, prefixes: string[]) => 
        prefixes.some(p => str.toLowerCase().startsWith(p));

    if (startsWithAny(browserLang, ['ru', 'by', 'kk', 'uk', 'mn'])) {
      return 'ru';
    }
    return 'en'; // для всех остальных локалей
  };

  const [lang, setLang] = useState<Language>(getInitialLang);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    } catch (e) {
      console.warn('Failed to save language to localStorage:', e);
    }
  }, [lang]);

  const t = useCallback((key: string): string => {
    const keys = key.split('.');
    let result: any = translations[lang];
    for (const k of keys) {
      if (result && result[k] !== undefined) {
        result = result[k];
      } else {
        return key;
      }
    }
    return result;
  }, [lang]);

  const toggleLanguage = useCallback(() => {
    setLang(prev => (prev === 'ru' ? 'en' : 'ru'));
  }, []);

  const setLanguage = useCallback((newLang: Language) => {
    if (newLang === 'ru' || newLang === 'en') {
      setLang(newLang);
    }
  }, []);

  return { lang, t, toggleLanguage, setLanguage };
};